import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

export function ThemeWrapper({ children }) {
  const location = useLocation()
  
  useEffect(() => {
    // Apply theme attribute based on route
    if (location.pathname.startsWith('/embed')) {
      document.documentElement.setAttribute('data-theme', 'fluid')
    } else {
      document.documentElement.removeAttribute('data-theme')
    }
  }, [location])
  
  return children
}